import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-browser-panel',
  templateUrl: './file-browser-panel.component.html',
  styleUrls: ['./file-browser-panel.component.scss']
})
export class FileBrowserPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
